import {
    type FC
} from "react";
import {
    View
} from "react-native";
import type IBarChartSignKeyProps from "./type";
import stylesheet, {
    useStyles
} from "./stylesheet";
import {
    NCoreUIKitTheme
} from "../../../../core/hooks";

const BarChartSignKey: FC<IBarChartSignKeyProps> = ({
    customTheme,
    color
}) => {
    const {
        shapeConfigs,
        radiuses
    } = NCoreUIKitTheme.useContext(customTheme);

    const {
        container: containerDynamicStyle
    } = useStyles({
        shapeConfigs,
        radiuses,
        color
    });

    return <View
        style={[
            stylesheet.container,
            containerDynamicStyle
        ]}
        aria-hidden={true}
    />;
};
export default BarChartSignKey;
